<template>
  <div class="rs-not-editable">
    <label v-if="label">{{ label }}</label>
    <div class="row m-0">
      <div
        v-if="icon"
        class="input-group-text flex-grow-0"
      >
        <RsIcon :icon="icon" />
      </div>
      <div
        class="value flex-grow-1"
        v-html="$utils.decodeHtml(value)"
      />
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsFormNotEditable',

  props: {
    id: String,
    icon: String,
    label: String,
    value: [String, Number, Object],
  },
  data() {
    return {
      isUnlocked: false,
      importHover: false,

      valid: null,
    };
  },
});
</script>
<style lang="scss">
@import '@/styles/_variables.scss';

.rs-not-editable {
  position: relative;
  margin-bottom: 1rem;

  label {
    display: inline-block;
    margin-bottom: 0.5rem;
    font-size: $form-label-font-size;
    font-weight: $form-label-font-weight;
  }
  .value {
    width: 100%;
    height: 40px;
    line-height: $input-line-height;
    border-radius: $input-radius;
    background: $gray-200;
    font-size: $input-font-size;
    color: $input-color;
    padding: 0.6rem 1.5rem 0.5rem 0.5rem;
  }
}
</style>
